import { Outlet } from 'react-router-dom'

const Naac = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default Naac
